module.exports = __webpack_public_path__ + "9bfba56cc581a775538445960175d6b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2094_teaser_image.jpg
// module id = 594
// module chunks = 0